import { SessionId } from '@hewey/shared'

// True only in the iOS build (`--mode ios`, client/.env.ios). That build keeps
// the session ID in Capacitor Preferences and sends it as a Bearer token. The
// website uses the HttpOnly cookie.
//
// Defined here and not in config.ts: Rolldown only leaves the Capacitor chunk
// out of the website build when this constant sits in the same module as the
// dynamic import below.
export const TOKEN_AUTH = import.meta.env.VITE_AUTH_MODE === 'token'

// Every function below is a no-op in the website build.
const KEY = 'session'

// Resolves to the module, not the plugin: the plugin is a Proxy that claims
// every method, `then` included, so a promise resolving to it throws.
const plugin = () => import('@capacitor/preferences')

// Read once per launch, then kept in step by set/clear.
let cached: Promise<SessionId | null> | null = null

export const getToken = (): Promise<SessionId | null> => {
	if (!TOKEN_AUTH) return Promise.resolve(null)
	cached ??= plugin().then(async ({ Preferences }) => {
		const { value } = await Preferences.get({ key: KEY })
		const parsed = SessionId.safeParse(value)
		if (parsed.success) return parsed.data
		if (value !== null) await Preferences.remove({ key: KEY })
		return null
	})
	return cached
}

export const setToken = async (token: SessionId): Promise<void> => {
	if (!TOKEN_AUTH) return
	cached = Promise.resolve(token)
	const { Preferences } = await plugin()
	await Preferences.set({ key: KEY, value: token })
}

export const clearToken = async (): Promise<void> => {
	if (!TOKEN_AUTH) return
	cached = Promise.resolve(null)
	const { Preferences } = await plugin()
	await Preferences.remove({ key: KEY })
}
